import {
  OPT_TASKS_LIST_TYPE_ALL,
  OPT_TASKS_LIST_TYPE_ALL_VALUE,
  OPT_TASKS_LIST_TYPE_EMAIL,
  OPT_TASKS_LIST_TYPE_EMAIL_VALUE,
  OPT_TASKS_LIST_TYPE_GROUP,
  OPT_TASKS_LIST_TYPE_GROUP_VALUE,
  OPT_TASKS_LIST_TYPE_SMS,
  OPT_TASKS_LIST_TYPE_SMS_VALUE
} from 'Constants/'
import { Select } from 'mailup-web-components'
import { searchState } from 'Pages/TasksList/recoil/state/search'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

export const InputType = ({ onChange }) => {
  const intl = useIntl()
  const [{ action }, setSearchParams] = useRecoilState(searchState)
  const { current: options } = useRef([
    {
      label: intl.formatMessage({ id: OPT_TASKS_LIST_TYPE_ALL }),
      value: OPT_TASKS_LIST_TYPE_ALL_VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_TASKS_LIST_TYPE_EMAIL }),
      value: OPT_TASKS_LIST_TYPE_EMAIL_VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_TASKS_LIST_TYPE_SMS }),
      value: OPT_TASKS_LIST_TYPE_SMS_VALUE
    },
    {
      label: intl.formatMessage({ id: OPT_TASKS_LIST_TYPE_GROUP }),
      value: OPT_TASKS_LIST_TYPE_GROUP_VALUE
    }
  ])

  const handleInputChange = (e) => {
    const val = e
    setSearchParams((prev) => ({
      ...prev,
      action: val
    }))
  }

  return (
    <Select
      searchable={false}
      options={options}
      onChange={handleInputChange}
      value={action}
    />
  )
}

InputType.propTypes = {
  onChange: PropTypes.func
}
